import has from 'lodash/has';
import {modify} from "mythil/object";
import getConfig from "~/config";
import identify from "~/identify";

export default function clearMessages(model, except = []) {
    let { errorSources, messageSources } = getConfig();

    for(let errorSource of errorSources) {
        if(except.indexOf(errorSource) > -1) { continue; }
        
        let path  = `${errorSource}.error`;

        if(!has(model, path)) { continue; }

        model = modify(model, path, null);

        model = modify(model, `${errorSource}.status`, (status) => status === identify.STATUS_ERRORED ? null : status);
    }

    for(let messageSource of messageSources) {
        if(except.indexOf(messageSource) > -1) { continue; }
        
        let path = `${messageSource}.value.messages`;
        if(!has(model, path)) { continue; }
        model = modify(model, path, []);

        model = modify(model, `${messageSource}.status`, (status) => status === identify.STATUS_ERRORED ? null : status);
    }

    return model;
}

export function clearItemMessages(model) {
    return clearMessages(model, ['customActionResult', 'results'])
}